import EventBus from '@/helpers/event-bus';
import ApplicationsService from '@/services/Applications/ApplicationsService';

import { set } from '../storeHelpers';

const state = {
  applications: [],
  collectionApplications: [],
  current: null,
  parent: null
};


const actions = {
  async getApplications({ commit }) {
    try {
      const { data } = await ApplicationsService.getApplications();

      if (data.length) {
        commit('setApplications', data);
      }
    } catch (error) {
      console.error(error.message);
    }
  },
  collectionApplications({ commit }, data) {
    commit('collectionApplications', data);
  },
  current({ commit }, data) {
    commit('current', data);
  },
  applicationParent({ commit }, data) {
    commit('applicationParent', data);
  },
  save() {
    return ApplicationsService.save(state.current).then(() => {

    });
  },
  async saveOrder(_, credentials) {
    try {
      const { data } = await ApplicationsService.saveOrder(credentials);
      if (data && data.status === 1) {
        EventBus.$emit('snotifySuccess', 'Updating tree success.');
      }
    } catch (error) {
      EventBus.$emit('snotifyError', 'Updating tree error.');
    }
  },
  async remove({ dispatch }, applicationId) {
    try {
      const { data } = await ApplicationsService.removeApplication(applicationId);
      if (data && data.status === 1) {
        EventBus.$emit('snotifySuccess', 'Element deleted.');
        dispatch('getApplications');
      }
    } catch (error) {
      if (error.response.data.errors.length) {
        EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
      } else {
        EventBus.$emit('snotifyError', 'Element deleted error.');
      }
    }
  },
  async changeVisibility({ dispatch }, data) {
    try {
      const response = await ApplicationsService.changeVisibility(data);

      if (response.data && response.data.status === 1) {
        dispatch('getApplications');
      }

      EventBus.$emit('snotifySuccess', 'Updating visibility success.');
    } catch (error) {
      EventBus.$emit('snotifyError', 'Updating visibility error.');
    }
  }
};

const mutations = {
  setApplications: set('applications'),
  collectionApplications: set('collectionApplications'),
  current: set('current'),
  applicationParent: set('parent'),
};

const getters = {
  applications(state) {
    return state.applications;
  },
  treeApplications(state) {
    const tree = objectToArray(deepCopy(state.applications));

    function traverse(tree) {
      tree.forEach((e) => {
        e.title = e.name;

        if (typeof e.children !== 'undefined' && e.children.length > 0) {
          traverse(e.children);
        }
        else {
          e.isLeaf = true;
        }

        e.data = {};
        if (e.parent_id) {
          e.data.parent_id = e.parent_id;
        }
        else {
          e.data.parent_id = null;
        }
        e.data.id = e.id;
        e.data.name = e.name;
        e.data.visible = e.visible;
      });
    }
    traverse(tree);
    return tree;
  },
  collectionApplications(state) {
    return state.collectionApplications;
  },
  current(state) {
    return state.current;
  },
  applicationParent(state) {
    return state.parent;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
